const muiButton = (theme) => {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '6px',
          textTransform: 'none',
          fontWeight: 500,
          padding: '6px 16px',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        sizeSmall: {
          padding: '5px 16px',
        },
        sizeMedium: {
          padding: '10px 35px',
        },
        sizeLarge: {
          padding: '16px 48px',
        },
        // contained
        containedInherit: {
          color: theme.palette.grey[800],
          '&:hover': {
            backgroundColor: theme.palette.grey[400],
          },
        },
        containedPrimary: {
          color: theme.palette.common.white,
          backgroundColor: theme.palette.green.primary,
          fontWeight: 500,
          '&:hover': {
            backgroundColor: theme.palette.green[3],
          },
        },
        containedSecondary: {
          backgroundColor: theme.palette.neutral.main,
          color: theme.palette.neutral900.main,
          '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.neutral100.main,
          },
          '&:active': {
            backgroundColor: theme.palette.primary300.main,
            color: theme.palette.neutral100.main,
          },
          '&.Mui-disabled': {
            backgroundColor: theme.palette.neutral700.main,
            color: theme.palette.neutral500.main,
          },
        },
        outlinedInherit: {
          color: theme.palette.grey[4],
          border: `2px solid ${theme.palette.grey[4]}`,

          '&:hover': {
            color: theme.palette.green.primary,
            border: `2px solid ${theme.palette.green.primary}`,
            backgroundColor: theme.palette.action.hoverPrimary,
          },
        },
        outlinedPrimary: {
          color: theme.palette.grey[4],
          fontWeight: 500,
          border: `1px solid ${theme.palette.grey[4]}`,

          '&:hover': {
            color: theme.palette.green.primary,
          },
        },
        outlinedSecondary: {
          backgroundColor: 'transparent',
          boxShadow: `inset 0 0 0 1px ${theme.palette.neutral.main}`,
          color: theme.palette.neutral.main,
          border: `none`,
          '&:hover': {
            boxShadow: `inset 0 0 0 2px ${theme.palette.neutral.main}`,
            border: `none`,
          },
          '&:active': {
            boxShadow: `inset 0 0 0 2px ${theme.palette.neutral.main}`,
            border: `none`,
          },
          '&.Mui-disabled': {
            boxShadow: `inset 0 0 0 1px ${theme.palette.neutral600.main}`,
            color: theme.palette.neutral500.main,
          },
        },
      },
      variants: [
        {
          props: { variant: 'bordered' },
          style: {
            color: theme.palette.grey[4],
            backgroundColor: theme.palette.common.white,
            border: `1px solid ${theme.palette.grey[4]}`,
            '&:hover': {
              border: `1px solid ${theme.palette.green.primary}`,
              color: theme.palette.green.primary,
              backgroundColor: theme.palette.pastel.green,
            },
            '&:disabled': {
              color: theme.palette.grey[1],
            },
          },
        },
        {
          props: { variant: 'correct' },
          style: {
            color: theme.palette.green.primary,
            backgroundColor: theme.palette.pastel.green,
            border: `1px solid ${theme.palette.green.primary}`,
            fontWeight: 500,
            '&:hover': {
              backgroundColor: theme.palette.pastel.green,
            },
            '&:disabled': {
              color: theme.palette.green.primary,
            },
          },
        },
        {
          props: { variant: 'wrong' },
          style: {
            backgroundColor: theme.palette.pastel.red,
            border: `1px solid ${theme.palette.red[1]}`,
            color: theme.palette.red[1],
            fontWeight: 500,
            '&:hover': {
              backgroundColor: theme.palette.pastel.red,
            },
            '&:disabled': {
              color: theme.palette.red[1],
            },
          },
        },
        {
          props: { variant: 'ghost' },
          style: {
            border: 'none',
            fontWeight: 500,
            backgroundColor: 'transparent',

            '&:hover': {
              backgroundColor: theme.palette.neutral700.main,
            },
            '&:active': {
              backgroundColor: theme.palette.primary500.main,
            },
            '&.Mui-disabled': {
              backgroundColor: theme.palette.neutral900.main,
              color: `${theme.palette.neutral500.main} !important`,
            },
          },
        },
      ],
    },
  };
};

export default muiButton;
